/**
 * User Role types
 */
export enum UserRole {
  User = 'dx-portal',
  Admin = 'dx-portal:admin',
  Agent = 'dx-portal:agent',
  AgentAdmin = 'dx-portal:agent:admin',
  Internal = 'dx-portal:internal'
}
